module.exports = __webpack_public_path__ + "static/media/au-qld.6e93af98.svg";